import { Component, OnInit, NgZone, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import $ from 'jquery';
declare var $: any;
@Component({
  selector: 'app-topic-items',
  templateUrl: './topic-items.component.html',
  styleUrls: ['./topic-items.component.scss']
})
export class TopicItemsComponent implements OnInit {
  public dialog: MatDialog;
  topics = [];
  topic = "";
  dataOptions = [];
  subTopics = [];
  openSubTopicPanel: Boolean = false;
  topicId: String = "";

  constructor(
    public dialogRef: MatDialogRef<TopicItemsComponent>,
    private ngZone: NgZone,
    private _http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    ngZone.run(() => {
      _http.get(environment.url + '/getAllTopics/' + localStorage.getItem('organization')).subscribe((response) => {
        if (response['data'].length > 0) {
          this.topics = response['data'];
        }
        if (this.data.fieldTopic.length > 0) {
          this.topic = this.data.fieldTopic.split(', ');
        }

        // For first time configurations
        for (let i=0; i < this.topics.length; i++) {
          if (this.data.fieldOptions.length === 0) {
            
            let obj = {
              label: "",
              value: "",
              visible: true,
              options: []
            };
            obj.label = this.topics[i].name;
            obj.value = this.topics[i]._id;
            this.dataOptions.push(obj);

            let subTopics = this.topics[i]['sub_topics'];
            subTopics.forEach((subTopic) => {
              let subTopicObj = {
                label: "",
                visible: true,
                value: ""
              };
              subTopicObj.label = subTopic;
              subTopicObj.value = subTopic.toLowerCase();
              obj.options.push(subTopicObj);
            });

            this.topics[i].checked = true;
            if (this.topic.length > 0) {
              this.topic = this.topic + ", " + this.topics[i].name;
            } else {
              this.topic = this.topics[i].name;
            }
          }
        }

        if (this.data.fieldOptions.length === 0) {
          $("#form-topic").attr("data-topic", this.topic);
          $("#form-topic").attr("placeholder", this.topic);
          $("#form-topic").attr("data-placeholder", this.topic);
          $("#form-topic").attr("data-options", JSON.stringify(this.dataOptions));
        }
        
        // For configurations which are already exists
        if (this.data.fieldOptions.length === 0) {
          let predefinedTopics = this.data.fieldTopic.split(", ");

          this.topics.forEach((topic) => {
            delete topic.options;
            if (_.includes(predefinedTopics, topic.name)) {
              topic.checked = true;
            } else {
              topic.checked = false;
            }
          });
        }
      });
    });
   }

  ngOnInit() {
  }

  openSubTopicConfig(topic) {
    if (!topic.checked) {
      return;
    }
    this.topicId = topic._id;
    this.subTopics = [];
    this.openSubTopicPanel = true;
    this.dataOptions.forEach((topic) => {
      if (topic.value === this.topicId) {
        this.subTopics = topic.options;
      }
    });
  }

  onNoClick(): void {
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }

  onTopicCheck(i, topic, event): void {
    this.ngZone.run(() => {

      let obj = {
        label: "",
        value: "",
        visible: true,
        options: []
      };

      let name = this.topics[i].name
      if (event.currentTarget.checked) {
        obj.label = this.topics[i].name;
        obj.value = this.topics[i]._id;
        let subTopics = this.topics[i]['sub_topics'];
        subTopics.forEach((subTopic) => {
          let subTopicObj = {
            label: "",
            visible: true,
            value: ""
          };
          subTopicObj.label = subTopic;
          subTopicObj.value = subTopic.toLowerCase();
          obj.options.push(subTopicObj);
        });
        this.dataOptions.push(obj);
        if (this.topic.length > 0) {
          let predefinedTopics = this.topic.split(", ");
          if (!_.includes(predefinedTopics, this.topics[i].name)) {
            this.topic = this.topic + ", " + this.topics[i].name;
          }
        } else {
          this.topic = this.topics[i].name;
        }
      } else {
        if (this.topic.length > 0) {
          var topics: any = [];
          if (typeof this.topic === 'string') {
            topics = this.topic.split(', ');
          } else {
            topics = this.topic;
          }
          this.topic = "";
          for (let j=0; j < this.dataOptions.length; j++) {
            if (name === this.dataOptions[j].label) {
              this.dataOptions.splice(j, 1);
            }
          }

          for (let j=0; j < topics.length; j++) {
            if (topics[j] === this.topics[i].name) {
              topics.splice(j, 1);
              this.topic = topics.join(', ');
            }
          }
          
        }
      }
      $("#form-topic").attr("data-topic", this.topic);
      $("#form-topic").attr("placeholder", this.topic);
      $("#form-topic").attr("data-placeholder", this.topic);
      $("#form-topic").attr("data-options", JSON.stringify(this.dataOptions));
      this.topics[i].checked = event.currentTarget.checked;
    });
  }

  onSubTopicChange(i, subTopic, event): void {
    if (event.currentTarget.checked) {
      this.dataOptions.forEach((topic) => {
        if (this.topicId === topic.value) {
          for (let i=0; i < topic["options"].length; i++) {
            if (topic["options"][i]["label"] === subTopic) {
              topic["options"][i]["visible"] = true;
            }
          }
        }
      });
    } else {
      this.dataOptions.forEach((topic) => {
        if (this.topicId === topic.value) {
          for (let i=0; i < topic["options"].length; i++) {
            if (topic["options"][i]["label"] === subTopic) {
              topic["options"][i]["visible"] = false;
            }
          }
        }
      });
    }
    $("#form-topic").attr("data-options", JSON.stringify(this.dataOptions));
  }

}
